import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'
import { FastingFeelings } from 'Containers/steps'

const stepImages: ReinforcementScreenBackgrounds<FastingFeelings> = {
  o: {
    [FastingFeelings.steady]: images.energyLevelInfoSteady,
    [FastingFeelings.unsteady]: images.energyLevelInfoUnsteady,
    [FastingFeelings.low]: images.energyLevelInfoLow
  }
}

interface EnergyLevelInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const EnergyLevelInfoScreen: FC<EnergyLevelInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { fasting_feelings: fastingFeelings = FastingFeelings.unsteady } = appState.selections ?? {}
    const gender = 'o' // universal
    return {
      localePrefix: `reinforcementScreens.energy_level_info.${gender}.${fastingFeelings}`,
      backgroundImagePath: stepImages[gender]![fastingFeelings as FastingFeelings]
    }
  }, [appState.selections?.fasting_feelings])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default EnergyLevelInfoScreen
